import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';

const LASTRESULTREASONS = {
    'Non-Working Number' : ['Busy signal', 'A message from the phone company', 'A long tone or other non-human type noise', 'A fax line', 'A call centers automated voice prompt', 'The weather line' ],
    'Incorrect Person' : ['Automated System', 'Weather Line'],
}

const styles = theme => ({
  root: {
    margin: 0,
   // padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
   // right: theme.spacing(1),
   // top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
  //  padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
 //   padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  console.log(props)
  const { lastResult, lastActionType, open, handleClose, handleUpdate } = props
  if(!lastResult){
    return null
  }
  const [selection, setSelection] = React.useState();
  const [errorMessage, setErrorMessage] = React.useState();
  const { [lastResult] : selectedLastResult } = LASTRESULTREASONS
   
    const controls = selectedLastResult.map((reason) => {
        return <FormControlLabel
        key={reason}
        value={reason}
        control={<Radio color="primary" />}
        label={reason}
        labelPlacement="end"
      />
    })
  
  const handleChange = (event) => {
    console.log(event.target.value)
    setSelection(event.target.value)
  }
  const agree = async() => {

    const {lead, lastActionType } = props
    const { leadID } = lead
    const update = {leadID, lead, lastResult, refundReason: lastResult, refundOption: selection}

    console.log(JSON.stringify(update))
    handleClose(update)

  }
  
  return (
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title">
        This last result code will trigger a refund request
     
        </DialogTitle>
        <DialogContent>
          <FormLabel component="legend">Refund Options</FormLabel>
          <RadioGroup aria-label="position" name="position" value={selection} onChange={handleChange} row>
              {controls}
          </RadioGroup>
          <Typography gutterBottom>
            By selecting "I AGREE," you agree to our <a style={{color: '#ADD8E6'}} href='https://www.sonicleads.com/return-policy' target="blank">refund policy</a>. For questions regarding our refund policy, please call us at (888) 448-7531 or submit a support request at <a style={{color: '#ADD8E6'}}  href='https://www.sonicleads.com/support' target="blank"> https://www.sonicleads.com/support </a>
          </Typography>
          <Typography gutterBottom style={{marginTop:10}}>
      <strong>Please be advised - </strong> Making false requests for refunds will result 
      in a fee and longer refund timelines for your actual non-working numbers.
      </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {handleClose()}} color="primary">
            Close
          </Button>
          <Button onClick={() => {agree()}} color="primary">
            I Agree
          </Button>
        </DialogActions>
           {errorMessage}
      </Dialog>
 
  );
}



// WEBPACK FOOTER //
// ./src/components/Leads/RefundAgreement.js